import { Module } from '@nestjs/common'
import { BillingController, CustomerPaymentController, WebhookController } from './controllers'
import { BillingService, StripeService } from './services'

@Module({
	controllers: [BillingController, WebhookController, CustomerPaymentController],
	providers: [StripeService, BillingService],
})
export class BillingModule {}
